const header = document.querySelector(".site-header__sticky");

const headroom = new Headroom(header, {
  offset: 0,
  tolerance: {
    up: 0,
    down: 0
  },
  classes: {
    initial: "header--fixed",
    pinned: "slideUp",
    unpinned: "slideDown",
    top: "top",
    notTop: "not-top"
  }
});

// initialise
headroom.init();


// When the page is at the top, remove the slideDown class.
window.addEventListener("scroll", () => {
  if (window.pageYOffset === 0) {
    header.classList.remove("slideUp");
  }
});
